import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, tap } from 'rxjs'
import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ApiService } from 'app/services/api.service';
import { PlatformService } from 'app/services/platform.service';

@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {
    constructor(
        private translate: TranslateService,
        private api: ApiService,
        private platformService: PlatformService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('assets') || req.url.includes('cdn-lots.cosentino.com')) {
            return next.handle(req);
        }

        const token = localStorage.getItem('weToken');
        if (token){
            req = req.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json',
                    'X-Platform': this.platformService.getPlatform()
                }
            });
        }

        return next.handle(req).pipe(
            tap({
                error: (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        this.api.logout()
                    }
                    if(err.status === 401){
                        this.api.navigateToLoginError();
                    }
                }
                },
            })
        );
    }

}
